module.exports = __webpack_public_path__ + "img/login-icon-analyse.918cf347.png";